import React from 'react'
import { TitleImageSwitch } from 'components/TitleImageSwitch'
import { ImageCaption } from 'components/ImageCaption'
import { TABox } from 'components/TABox'
import { RelationQuiz } from 'components/RelationQuiz'

export const Microalgae = () => {
  return (
    <div id='algen'>
      <TitleImageSwitch
        title='Mikroalgen'
        sub='Mikroalgen als das neue Superfood oder lieber ein Steak 2.0 aus Reispulver?'
        number={3}
        bgpos='right'
        images={[
          require('images/microalgen_2.jpg'),
          require('images/microalgen_1.jpg')
        ]}
      />

      <div className='ui vertical very fitted segment'>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#A3C8AF' }}>
            <h3>Vorsicht, Algen auf der Schlachtbank!</h3>
            <h5>
              An der ETH Zürich züchtet ein Forscherteam Mikroalgen zum Essen.
              Die Idee ist, dass die Rohstoffe für unser Steak eines Tages an
              den Wänden von Hochhäusern oder im Untergrund in Biotanks
              gedeihen.
            </h5>
            <p>
              Sachte schwappt die helle Flüssigkeit in den Glaskolben auf dem
              sich rhythmisch bewegenden Untergrund hin und her. Die «Suppe» aus
              mikroskopisch winzigen, kugelförmigen Grünalgen der Gattung
              Chlorella erstrahlt beim Öffnen des Brutschranks in einer grellen
              Technofarbe, da sie kurz von einer Lampe angestrahlt wird. «Sie
              wachsen ganz ohne Licht, müssen von uns deshalb aber regelmässig
              mit Kohlenhydraten gefüttert werden», sagt die Forscherin Iris
              Haberkorn von der ETH Zürich. Der Vorteil dabei sei, dass die
              winzigen Einzeller dadurch nicht grün aussähen, als Lebensmittel
              später besser akzeptiert seien und höhere Ernteerträge möglich
              wären.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={require('images/algen_1.jpg')}
            title={'Versuche mit Mikroalgen'}
            caption={
              <>
                «Solche Mikroalgen, die hier im Glaskolben sind, können ohne
                weiteres auch auf unproduktiven Flächen mitten in Megastädten
                wachsen», sagt Iris Haberkorn von der ETH Zürich.Die Vision
                dabei sei, dass man solche «Urban Farming»-Produkte dann gleich
                noch vor Ort in kleinen Anlagen zu haltbaren Lebensmitteln
                verarbeite.
              </>
            }
            source={'Foto: ETH Zürich'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#A3C8AF' }}>
            <p>
              «Ein grünes Algensteak kann einmal ja ganz amüsant sein,
              langfristig aber keine Lösung liefern», erklärt der
              Lebensmitteltechnologe Alexander Mathys, der seit Januar 2022
              zusammen mit Haberkorn sowie Partnern von anderen Universitäten
              und aus der Industrie am ETH-Standort in Singapur urbane
              Food-Produktionsanlagen für Mikroalgen entwickelt. Dort probieren
              sie mit der Algenart Chlorella vulgaris beide Strategien aus:
              Wachstum mit Licht und ohne.
            </p>
            <p>
              Bei der ersten Methode sollen die in Wasser lebenden,
              pflanzenartigen Organismen eines Tages grossflächig in
              geschlossenen Röhren an Hochhäusern wuchern. Über spezielle Filter
              wird dabei das für die Fotosynthese wichtige CO<sub>2</sub> zuerst
              aus der Luft gefischt und danach ins Wasser gepumpt. «Unter dem
              Strich könnte dies die Treibhausgasbilanz sogar verbessern», sagt
              Haberkorn. Bei der zweiten Methode will das Forscherteam die
              Produktion ohne Licht in grossen, geschlossenen Biotanks testen,
              die entweder auf dem Dach eines Gebäudes oder in einer Tiefgarage
              stehen könnten.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={require('images/algen_2.jpg')}
            title={'Grünes Kraftpaket'}
            caption={
              <>
                In der Anlage mit insgesamt 43'000 Glasröhren produziert die
                österreichische Firma Jongerius Ecoduna in Bruck die
                mikroskopisch kleinen Mikroalgen Chlorella und Spirulina, die
                mit blossem Auge nicht erkennbar sind. Das daraus gewonnene
                Pulver wird aufgrund der Proteine, Vitamine und Mineralstoffe
                als Nahrungsergänzung verwendet oder um Speisen mit
                einzigartigen Grüntönen aufzupeppen.
              </>
            }
            source={'Foto: Jongerius ecoduna'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#A3C8AF' }}>
            <p>
              Des weiteren laufen in Zürich Experimente mit der ebenfalls nur
              wenige Tausendstel Millimeter kleinen Mikroalge Spirulina, die wie
              Chlorella als Lebensmittel zugelassen ist und zum Beispiel als
              Quelle für die natürliche blaue Farbe in Smarties sorgt. Im
              österreichischen Bruck gibt es schon eine gigantische
              Mikroalgen-Farm, die mit Hilfe eines riesigen Glasrohrdickichts
              pro Jahr mehrere Tonnen Algenpulver für die Lebensmittelbranche
              produziert.
            </p>
            <p>
              Auch weil beim Fleisch die grüne oder blaue Farbe der Mikroalgen
              an Schimmel erinnern könnte, lassen die Forschenden an der ETH sie
              bei der Produktion im Dunkeln erst gar nicht entstehen. Das aus
              den in Tanks produzierten Mikroalgen gewonnene Gesamtprotein wird
              dann mit Hightech-Geräten aus der Schokoladen- und
              Teigwarenindustrie in Form gebracht und bei diesem kontrollierten
              Prozess zu faserigen Fleisch-Imitaten wie etwa Geschnetzeltem oder
              einem Schnitzel verarbeitet. Die Königsdisziplin ist jedoch ein
              täuschend echt aussehendes Steak, das aber auch im Geschmack dem
              Original sehr nah kommt.
            </p>
            <h4>«Fake-Fleisch» oft aus Erbsen</h4>
            <p>
              In einer Laborhalle der ETH Zürich optimiert ein Team um Erich
              Windhab mit Studierenden und Doktoranden derzeit weiter die
              Rezeptur und Struktur von herkömmlichem «Vegi-Fleisch». Dabei
              verändert es bei der bisher üblichen Proteinmasse adopelscus
              Hülsenfrüchten den Wassergehalt und variiert im Innern eines sehr
              komplexen Doppelschnecken-Extruders gezielt die einzelnen Druck-
              und Temperaturzonen.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={[
              require('images/algen_3.jpg'),
              require('images/algen_3_2.jpg')
            ]}
            title={'Erbsenpoulet aus dem Extruder'}
            caption={
              <>
                «Ursprünglich wurden diese wuchtig aussehenden, metallenen
                Extruder an der ETH Zürich für die Herstellung von besonders
                feiner Schokolade verwendet», erklärt der Forscher Kim Mishra.
                Inzwischen setzt man sie längst auch für die Produktion von
                Erbsenpoulet ein. Zudem werden neuartige Rezepte für
                Fleischersatzprodukte mit Mikroalgen derzeit getestet.
              </>
            }
            source={'Foto: Barbara Reye'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#A3C8AF' }}>
            <p>
              Am Ende des metallenen Monstrums kommt schliesslich ein flach
              gedrücktes, helles, ellenlanges Band heraus, das auf den ersten
              Blick nicht nach einem Fleischersatz aussieht. Doch zerpflückt man
              es mit den Händen, hat es tatsächlich die Fasereigenschaften von
              Poulet und irgendwie auch den Geruch. Es überrascht daher nicht,
              dass ein ehemaliger ETH-Laborkollege das erfolgreiche Schweizer
              Start-up Planted mitgegründet hat.
            </p>
            <p>
              «Die angewendeten Techniken lassen sich auch auf Spirulina und
              Chlorella übertragen», sagt der Forscher Kim Mishra. Er zeigt nun,
              wie sich mit modernen Verfahren der Lebensmittelproduktion
              theoretisch ein saftiges Steak-Imitat kreieren liesse. Zuerst
              drücken die Düsen des Doppelschnecken-Extruders nach einem
              vorgegebenen Muster die Form heraus. Anschliessend sorgen
              besonders bewegliche 6-Achsen-Roboterarme dafür, dass in
              verschiedenen Tiefen an einem bestimmten Ort die gewünschten Fette
              und Geschmacksträger in dem Stück «Fleisch» platziert werden.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={require('images/algen_5.jpg')}
            title={'Das Vegi-Steak 2.0'}
            caption={
              <>
                Für die israelische Firma Redefine scheinen die Tage von
                tierischem Fleisch gezählt zu sein. Mit 3D-Druckern stellt es
                inzwischen auch Steaks her. Dank dem raffinierten
                Hightech-Verfahren werden die pflanzlichen Zutaten gezielt
                Schicht für Schicht platziert.
              </>
            }
            source={'Foto: Getty Images'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#A3C8AF' }}>
            <TABox
              title={<>Die Fleisch-Pflanzer</>}
              caption={
                <>
                  Die meisten Fleischersatzprodukte werden heute aus Soja,
                  Weizen oder Erbsen hergestellt. Dabei wird das extrahierte
                  Pflanzenprotein in eine fleischähnliche, faserige Struktur
                  gebracht. Der pflanzliche Ursprung schont Umwelt und Klima.
                  Bald könnte das «Fake-Fleisch» auch aus Mikroalgen hergestellt
                  werden. Geschmack und Aussehen sollen an echtes Fleisch oder
                  an ein Lachsfilet erinnern. Warum wir vermutlich schon bald
                  mehr von den winzigen Wasserorganismen auf unserem Speiseplan
                  haben könnten.
                  <ul>
                    <li>
                      Mikroalgen stellen wie Erbsen oder Soja hochwertige
                      Proteinquellen dar. Sie können auch mitten in der Stadt
                      schnell wachsen.
                    </li>
                    <li>
                      Zudem besitzen sie gesunde Omega-3-Fettsäuren,
                      vergleichbar mit Fisch. Deshalb könnte der Verzehr der
                      aquatischen Einzeller auch gegen die Überfischung helfen.
                    </li>
                    <li>
                      Sie wachsen entweder bei Licht, können aber auch ganz im
                      Dunkeln mit Fütterung gedeihen.
                    </li>
                  </ul>
                </>
              }
            />
            <p>
              Die israelische Firma Redefine Meat kommt dank einem speziellen
              3D-Druck-Verfahren und einer raffinierten Zubereitung offenbar
              bereits sehr nah an das «echte» Steak-Erlebnis heran, überzeugte
              aber laut ersten Degustationsberichten vor ein paar Monaten nicht
              alle Gourmets. In Barcelona hat indes Nova Meat ebenfalls im
              vergangenen Jahr einen Prototyp für das Steak 2.0 entwickelt, das
              unter anderem aus Reis- und Erbsenpulver, Algenfasern und Roter
              Beete als Farbstoff besteht.
            </p>
            <p>
              In Wien ist es dem Start-up Revo Foods gelungen, erstmals einen
              veganen Räucherlachs aus dem 3D-Drucker zu produzieren, der recht
              authentisch aussieht und schmecken soll. Rund ein Dutzend
              Substanzen, darunter Erbsenproteine, pflanzliche Öle und Rot- und
              Braunalgen, werden in dem raffinierten Fisch-Imitat verarbeitet.
              «Wir sind jetzt am Up-Scaling, damit wir unser Produkt in Zukunft
              auch in grossen Mengen mit der neuen Technik produzieren können»,
              sagt die Biotechnologin Theresa Rothenbücher von Revo Foods.
              Bisher könne man den veganen Lachs in Österreich schon im
              Supermarkt kaufen, aber noch nicht mit der gewünschten Textur des
              mit «Bio-Tinte» im 3D-Drucker hergestellten Prototyps.
            </p>
          </div>
        </div>
        <div className='ui container'>
          <ImageCaption
            img={require('images/algen_4.jpg')}
            title={'Gedruckte Lammfleisch-Imitate'}
            caption={
              <>
                Das Vegi-Fleisch ahmt nicht nur den Geschmack von Muskeln, Blut
                und Fett immer besser nach, sondern sieht dem Original zunehmend
                ähnlicher. Die Food Start-ups sind momentan daran, dass
                dreidimensional gedruckte Fleisch-Imitat massentauglich zu
                machen, so dass man es in Zukunft auch ganz normal im Handel
                erwerben kann.
              </>
            }
            source={'Foto: Redefine Meat'}
          />
        </div>
        <div className='ui text container'>
          <div className='ta text' style={{ backgroundColor: '#A3C8AF' }}>
            <h4>Mikroalgen-Garten vor der Tür</h4>
            <p>
              Der Novel-Food-Markt hat aufgrund der starken Nachfrage nach
              Fleischalternativen insbesondere bei Flexitariern eine eigene
              Geschwindigkeit entwickelt, der die Gesetze jedoch
              hinterherhinken. So würde die Österreicher Jungunternehmer-Crew
              eigentlich viel lieber Mikroalgen aufgrund des guten
              Fettsäurenverhältnisses, der Vitamine und der vielen Proteine für
              ihren veganen Lachs verwenden. Doch sind die winzigen Einzeller in
              Europa bisher noch nicht für Fisch- und Fleischersatzprodukte
              zugelassen, sondern unter anderem erst für Tabletten,
              Pflanzendrinks sowie Sportlernahrung.
            </p>
            <p>
              Der Stadtstaat Singapur bietet eine Art Labor für die Ernährung
              der Zukunft, weil es in seiner urbanen Umgebung keine grossen
              Flächen für Landwirtschaft gibt. «Aus diesem Grund wollen wir dort
              Mikroalgen in Biotanks unter Hochhäusern züchten», sagt Iris
              Haberkorn. Das Ziel sei, die Lebensmittel lokal zu produzieren, zu
              ernten und individuell aufzubereiten. Mit einem kleinen
              3D-Drucker, der so gross wie eine Kaffeemaschine ist, könnte man
              die entsprechenden Zutaten wie etwa auch wertvolle Substanzen aus
              Mikroalgen hinzugeben und je nach gesundheitlichen Bedürfnissen
              anpassen. Haberkorn: «Ein Smartphone oder eine Sportuhr würde
              einem dann zum Beispiel sagen: Heute noch mehr Vitamin B, Zink
              oder Proteine und den Kalorienverbrauch anzeigen.»
            </p>
          </div>
        </div>{' '}
        <div className='ui container'>
          <div className='visual'>
            <RelationQuiz
              colors={['#FFE462', '#202346', '#356D48']}
              labels={['Soja', 'Rindfleisch']}
              title={
                <>
                  <b>Soja vs. Rind</b>
                  <br />
                  Da es noch keine Burger mit Mikroalgen gibt, ist das Quiz mit
                  Soja. Was schätzen Sie?
                </>
              }
              subline={
                <>
                  Die berechneten Werte sind Durchschnittswerte und können je
                  nach Ausgangslage und Produktionsbedingungen variieren.
                  <br />{' '}
                  <span>
                    Quelle: Fleisch der Zukunft/ Trendanalyse 2020/
                    Umweltbundesamt Berlin
                  </span>
                </>
              }
              questions={[
                {
                  q: (
                    <>
                      Wie ist das <b>Verhältnis der Landflächen*</b>, welche für
                      die Produktion von 1kg Soja und 1 kg Rindfleisch benötigt
                      werden?
                    </>
                  ),
                  max: 92,
                  rel: [1, 63.9],
                  start: 92 / 2,
                  a: [1.44, 92],
                  unit: (
                    <>
                      m<sup>2</sup>
                    </>
                  )
                },
                {
                  q: (
                    <>
                      Wie gross ist das{' '}
                      <b>
                        Verhältnis der emittierten Treibhausgase* in CO
                        <sub>2</sub>-Äquivalenten
                      </b>{' '}
                      bei der Produktion von 1 kg Soja und 1 kg Rindfleisch?
                    </>
                  ),
                  max: 30.5,
                  rel: [1, 26.1],
                  start: 30.5 / 2,
                  a: [1.2, 30.5],
                  unit: (
                    <>
                      kg CO<sub>2</sub>
                    </>
                  )
                },
                {
                  q: (
                    <>
                      Wie ist das <b>Verhältnis von verbrauchtem Wasser*</b> für
                      die Produktion von 1kg Soja und 1 kg Rindfleisch?
                    </>
                  ),
                  max: 15415,
                  rel: [1, 8.6],
                  start: 15415 / 2,
                  a: [1800, 15415],
                  unit: <>l</>
                }
              ]}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
